module.exports = __webpack_public_path__ + "img/yy3.60fb2863.png";